export enum SECTIONS {
  // Admin rebuild: course sections and the settings namespace.
  OVERVIEW = 'overview',
  REVIEW = 'review',
  TEAM = 'team',
  CERTIFICATE = 'certificate',
  SETTINGS = 'settings',

  PREVIEW = 'preview',
  MODULES = 'modules',
  EXAMPLES = 'examples',
  MODULE = 'module',
  WORKSPACE = 'workspace',
  WORKFLOW = 'workflow',
  COURSES = 'courses',
  COURSE = 'course',
  COURSE_NODE = 'node',
  COURSE_PROGRESS = 'progress',
  GROUPS = 'groups',
  SYSTEMS = 'integrations',
  ADMINISTRATORS = 'admins',
  CERTIFICATES = 'certificates',
  VARIABLE = 'variable',
  VARIABLES = 'variables',
  THEME = 'theme',
  ACCOUNT = 'account',
  LEARNERS = 'learners',
  LEARNER = 'learner',
  INVITES = 'invites',
  INTEGRATIONS = 'integrations',
  DIALOGS = 'dialogs',
  SHARE = 'share',
  EDIT = 'edit',
  SCENE = 'scene',
}
